module.exports = __webpack_public_path__ + "img/kubok.a6284f3d.png";